import { ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

export function AppWrapper({ children }: Props) {
  return <div className="min-h-full w-full max-w-6xl mx-auto">{children}</div>;
}
